module.exports = __webpack_public_path__ + "2f4889b2f204007fe6698d77d635626e.gif";